import React from 'react';

function Wrapper(props) {
  const { isItinerariesItem, children, hidden } = props;

  if (isItinerariesItem && hidden) {
    return <s>{children}</s>;
  }

  return <span>{children}</span>;
}

export default React.memo(Wrapper);
